import type { MarginLevel } from './types';

/** Gross margin on the sale price, (price − cost) ÷ price — same rule as the server. */
export function marginOf(price: number | null | undefined, cost: number | null | undefined, target: number, warn: number): { margin: number | null; level: MarginLevel | null } {
  if (price == null || cost == null || !Number.isFinite(price) || price <= 0) return { margin: null, level: null };
  const margin = Math.round(((price - cost) / price) * 1000) / 10;
  const level: MarginLevel = margin < 0 ? 'loss' : margin < warn ? 'weak' : margin < target ? 'warn' : 'good';
  return { margin, level };
}

/** A price per single unit while the product is a pack (₪0.99 a pen of a 48-pen pack) — same rule as the server. */
export function isUnitPrice(price: number, packPrice: number | null, packs: number | null) {
  if (!packPrice || !packs || packs < 2 || price <= 0) return false;
  const asPack = price * packs;
  return price < packPrice * 0.45 && asPack >= packPrice * 0.55 && asPack <= packPrice * 1.7;
}

export type ProductCost = { cost: number | null; fromPack: boolean; basePrice: number | null; packs: number | null };

/** Cost of one sold unit at this price: the pack cost, or its share when the price is per unit. */
export function unitCost(price: number, c: ProductCost | undefined): number | null {
  if (!c || c.cost == null) return null;
  return isUnitPrice(price, c.basePrice, c.packs) ? c.cost / c.packs! : c.cost;
}
